import Vue from 'vue'
// import {
//   extend,
//   ValidationObserver,
//   ValidationProvider,
// } from 'vee-validate'
// import {
//   email,
//   max,
//   min,
//   numeric,
//   required,
// } from 'vee-validate/dist/rules'
// import * as VeeValidate from "vee-validate";
import VeeValidate from 'vee-validate';

// extend('email', email)
// extend('max', max)
// extend('min', min)
// extend('numeric', numeric)
// extend('required', required)

Vue.use(VeeValidate)
// Vue.component('validation-provider', ValidationProvider)
// Vue.component('validation-observer', ValidationObserver)
